export interface SerializedDevice {
  deviceId: string;
  label: string;
}

export type MediaStreamType = "audio" | "video";

export interface DeviceInfoState {
  devices: MediaDeviceInfo[];
  permissions: Record<MediaStreamType, PermissionState>;
  activeDevices: Record<DeviceType, null | SerializedDevice>;
  preEnable: {
    audioInput: boolean;
    videoInput: boolean;
  };
  noCamOrMic: boolean;
  isMobile: boolean;
}

export const enum PermissionState {
  NOT_GRANTED,
  GRANTED,
}

export type DeviceType = "audioInput" | "audioOutput" | "videoInput";
